var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"currentColor","strokeWidth":"1","fill":"currentColor","fillRule":"evenodd"},React.createElement("g",{"id":"next-(1)","fill":"currentColor","fillRule":"nonzero"},React.createElement("path",{"d":"M26.3719031,23.6280969 L3.28387219,0.540066023 C2.5195321,-0.198119653 1.30154828,-0.176925562 0.563362609,0.587414523 C-0.156785542,1.33304068 -0.156785542,2.51506218 0.563362609,3.2605756 L22.2911387,24.9883517 L0.563362609,46.7161278 C-0.187787536,47.4673907 -0.187787536,48.6853745 0.563362609,49.4366374 C1.31473822,50.1877875 2.53260931,50.1877875 3.28387219,49.4366374 L26.3719031,26.3486065 C27.1230532,25.5972309 27.1230532,24.3793598 26.3719031,23.6280969 Z","id":"Path"}))));
}

Arrow.defaultProps = {"width":"27px","height":"50px","viewBox":"0 0 27 50"};

module.exports = Arrow;

Arrow.default = Arrow;
